import { initialState } from '../../../data/setup/oosBillSets/initialState.oosBillSets.data';
import {
  fetchhOosBillSetsData as fetchhOosBillSetsDataAPI,
  fetchCountriesData as fetchCountriesAPI,
  fetchCurrenciesData as fetchCurrenciesAPI,
  fetchServiceTypeData as fetchServiceTypeAPI,
  addBillSets as addBillSetsAPI,
  updateBillSets as updateBillSetsAPI,
  fetchOosBillSetsById as fetchOosBillSetsByIdAPI,
  deleteBillSet as deleteBillSetAPI,
} from '../../../apis/oosBillSetsAPI';
import { ACTION_OOS_BILL_SETS } from '../../../constants/actionCreator';
import {
  ERROR_MESSAGE,
  handlePending,
  handleRejection,
  OSS_BILL_SETS_DATA,
} from '../../../constants';
import { createAsyncThunkWrapper } from '../../../services/common/asyncThunkWrapper';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
export const fetchOosBillSets = createAsyncThunkWrapper(
  ACTION_OOS_BILL_SETS.FETCH_OOS_BILL_SETS_SUGGESTIONS,
  fetchhOosBillSetsDataAPI
);

export const fetchOosBillSetsAllData = createAsyncThunkWrapper(
  ACTION_OOS_BILL_SETS.FETCH_OSS_BILL_SETS_ALL_DATA,
  fetchhOosBillSetsDataAPI
);

export const fetchCountriesData = createAsyncThunk(
  ACTION_OOS_BILL_SETS.FETCH_COUNTRIES,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchCountriesAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchCurrenciesData = createAsyncThunk(
  ACTION_OOS_BILL_SETS.FETCH_CURRENCIES,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchCurrenciesAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchServiceTypeData = createAsyncThunk(
  ACTION_OOS_BILL_SETS.FETCH_SERVICE_TYPE,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchServiceTypeAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addBillSets = createAsyncThunk(
  ACTION_OOS_BILL_SETS.ADD_BILL_SETS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await addBillSetsAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateBillSets = createAsyncThunk(
  ACTION_OOS_BILL_SETS.UPDATE_BILL_SETS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await updateBillSetsAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteBillSets = createAsyncThunk(
  ACTION_OOS_BILL_SETS.EDIT_BILL_SETS,
  async (body, { rejectWithValue }) => {
    try {
      const response = await deleteBillSetAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const fetchOosBillSetsById = createAsyncThunk(
  ACTION_OOS_BILL_SETS.FETCH_OSS_BILL_SETS_BY_ID,
  async (body, { rejectWithValue }) => {
    try {
      const response = await fetchOosBillSetsByIdAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteBillSet = createAsyncThunk(
  ACTION_OOS_BILL_SETS.OSS_BILL_SET_DELETED,
  async (body, { rejectWithValue }) => {
    try {
      const response = await deleteBillSetAPI(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const oosBillSetsSlice = createSlice({
  name: 'oosBillSets',
  initialState,
  reducers: {
    resetValues: () => initialState,
    setSelectedValue: (state, action) => {
      state.nameContainsSelectedValue = action?.payload;
    },
    setSearchTerm: (state, action) => {
      state.nameContainsSearchTerm = action?.payload;
    },
    setSelectedRowData: (state, action) => {
      state.selectedRodData = action?.payload;
    },
    handleAddNewRule: (state, action) => {
      if (state.billSets?.length <= OSS_BILL_SETS_DATA.billsetLimit) {
        state.billSets =
          action?.payload?.length > 0
            ? [...state.billSets, ...action?.payload]
            : [];
      }
    },
    handleEditRule: (state, action) => {
      const { rowIndex, row } = action?.payload;
      state.billSets[rowIndex] = row;
    },
    handleDeleteRule: (state, action) => {
      const { allSelected } = action?.payload;
      const mydata = JSON.parse(JSON.stringify(state.billSets));
      state.billSets = mydata?.map((item, i) => {
        if (!item.isNew && allSelected.includes(i)) {
          item.isDeleted = true;
          item.rules = item?.rules?.map((itemR) => {
            return { ...itemR, isDeleted: true };
          });
        }
        return item;
      });
      state.billSets = state.billSets?.filter((item, index) => {
        if (item.isNew && allSelected?.includes(index)) {
          return false;
        }
        return true;
      });
    },
    handleAddValidationError: (state, action) => {
      state.billSetsErrors =
        action?.payload?.length > 0
          ? [...state.billSetsErrors, ...action?.payload]
          : [];
    },
    handleEditValidationError: (state, action) => {
      const { rowIndex, rowError } = action?.payload;
      state.billSetsErrors[rowIndex] = rowError;
    },
    handleDeleteValidationError: (state, action) => {
      const { allSelected } = action?.payload || {};
      const mydata = JSON.parse(JSON.stringify(state.billSetsErrors));
      state.billSetsErrors = mydata?.map((item, i) => {
        if (!item.isNew && allSelected.includes(i)) {
          item.isDeleted = true;
          item.rules = item.rules?.map((itemR) => {
            return { ...itemR, isDeleted: true };
          });
        }
        return item;
      });
      state.billSetsErrors = state.billSetsErrors?.filter((item, index) => {
        if (item.isNew && allSelected?.includes(index)) {
          return false;
        }
        return true;
      });
    },
    handleSelectedTab: (state, action) => {
      state.selectededTab = action?.payload;
    },
    handlebillSetsCreateType: (state, action) => {
      state.billSetsCreateType = action?.payload;
      if (action?.payload?.create) {
        state.selectedRodData = [];
      }
      // Reset Toaster flag false after creating new bill set below.
      state.isBillSetsCreated = false;
      //
    },
    handleBillSetsFormCancle: (state) => {
      state.billSetsCreateType = initialState.billSetsCreateType;
    },

    handleCheckboxChecked: (state, action) => {
      state.checkboxChecked = action?.payload;
    },
    handlebillSetsInfo: (state, action) => {
      state.billSetsInfo[action?.payload?.name] = action?.payload?.value;
    },
    handlebillSetsInfoError: (state, action) => {
      state.billSetsInfoError[action?.payload?.name] = action?.payload?.value;
    },
    handleIsBillsetAdded: (state, action) => {
      state.atLeastOneBillSetAdded = action?.payload;
    },
    handlePagination: (state, action) => {
      const { name, value } = action?.payload || [];
      state.pagination[name] = value;
    },
    backClickedSet:(state,action)=>{
      state.backClick=action?.payload;
    },
    resetBackValue:(state)=>{
      state.selectedRodData= [];
      state.searchSuggestions= [];
      state.totalBillsets=0;
      state.isNameContainDataFound=false;
      state.billSetsCreateType= { 
        create: false, 
        update: false 
      };
      state. loading= false;
      state.searchLoading= false;
      state.deleteButtonLoader= false;
      state.addBillsetLoading= false;
      state.isBillSetsCreated= false;  
      state.updateLoadding= false;
      state.dataUpdatingLoading= false;
      state.addBillSetsError= '';  
      state.isBillSetsUpdated=false;
      state.errors= {}; // You can store the form errors here 
      state.searchData= [];// You can store the service level data here
      state.selectededTab= 0;
      state.countries= [];
      state.currencies= [];
      state.serviceType= [];
      state.checkboxChecked={
        allChecked: false,    
        allSelected: [],
        ditermineChecked: false,
      };
      state.billSetsInfo= {
        name: '', 
        description: '',
        last_Modified_User_Id: 0,
        last_Modified_Timestamp: new Date(),  
      };
      state.billSetsInfoError= {
        name: null, 
        description: null
      };
      state.billSets= [{    
        countryId: 0,
        currencyId: 0,
        isNew: true,
        isDeleted: false,
        rules: [{
          serviceTypeId: 0,
          billCalcTypeID: 0,
          startTime: new Date().setHours(8, 0),
          endTime: new Date().setHours(17, 0),
          baseMinuteQty: '',
          baseFee: '',
          incrementMinuteQty: '',
          incrementFee: '',
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        },{
          serviceTypeId: 0,
          billCalcTypeID: 0,
          startTime: new Date().setHours(8, 0),
          endTime: new Date().setHours(17, 0),
          baseMinuteQty: '',
          baseFee: '',
          incrementMinuteQty: '',
          incrementFee: '',
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        },{
          serviceTypeId: 0,
          billCalcTypeID: 0,
          startTime: new Date().setHours(8, 0),
          endTime: new Date().setHours(17, 0),
          baseMinuteQty: '',
          baseFee: '',
          incrementMinuteQty: '',
          incrementFee: '',
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        }],
        
      }];
      state.billSetsErrors= [{
        countryId: null,
        currencyId: null,
        isNew: true,
        isDeleted: false,
        rules: [{
          serviceTypeId: null,
          billCalcTypeID: null,
          startTime: null,
          endTime: null,
          baseMinuteQty: null,
          baseFee: null,
          incrementMinuteQty: null,
          incrementFee: null,
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        },{
          serviceTypeId: null,
          billCalcTypeID: null,
          startTime: null,
          endTime: null,
          baseMinuteQty: null,
          baseFee: null,
          incrementMinuteQty: null,
          incrementFee: null,
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        },{
          serviceTypeId: null,
          billCalcTypeID: null,
          startTime: null,
          endTime: null,
          baseMinuteQty: null,
          baseFee: null,
          incrementMinuteQty: null,
          incrementFee: null,
          isNew: true,
          isDeleted: false,
          billRuleID: 0,
        }]
      }];
      state.atLeastOneBillSetAdded= true;
      state.updateBillSetsMessage= '';
      state.pagination= {
        rowsPerPage: 25,
        page: 0,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOosBillSets.pending, (state) => {
        state.loading = true;
        state.searchSuggestions = [];
      })
      .addCase(fetchOosBillSets.fulfilled, (state, action) => {
        state.loading = false;
        state.searchSuggestions = action?.payload?.hardwareFees || [];
      })
      .addCase(fetchOosBillSets.rejected, handleRejection)

      .addCase(fetchOosBillSetsAllData.pending, (state) => {
        state.searchLoading = true;
        state.gridData = [];
        state.isNameContainDataFound = false;
        state.isBillSetsCreated = false;
        state.isBillSetDeleted = false;
        state.selectedRodData = [];
      })
      .addCase(fetchOosBillSetsAllData.fulfilled, (state, action) => {
        state.gridData = action?.payload?.hardwareFees ?  action?.payload?.hardwareFees : [];
        state.totalBillsets= action?.payload?.totalRecords ? action?.payload?.totalRecords : 0;
        state.isNameContainDataFound = true;
        state.searchLoading = false;
      })
      .addCase(fetchOosBillSetsAllData.rejected, (state) => {
        state.isNameContainDataFound = false;
        state.searchLoading = false;
      })
      .addCase(fetchCountriesData.pending, handlePending)
      .addCase(fetchCountriesData.fulfilled, (state, action) => {
        const newCountries = [...action?.payload];
        if (newCountries) {
          newCountries?.sort((a, b) => a.name - b.name);
        }
        state.countries = newCountries;
        state.loading = false;
      })
      .addCase(fetchCountriesData.rejected, handleRejection)

      .addCase(fetchCurrenciesData.pending, handlePending)
      .addCase(fetchCurrenciesData.fulfilled, (state, action) => {
        state.currencies = action?.payload
          ?.sort((a, b) => a.name - b.name)
          .map((item) => ({
            ...item,
            name: `${item.name} (${item.psCurrencyCode})`,
          }));
        state.loading = false;
      })
      .addCase(fetchCurrenciesData.rejected, handleRejection)

      .addCase(fetchServiceTypeData.pending, handlePending)
      .addCase(fetchServiceTypeData.fulfilled, (state, action) => {
        state.serviceType = action?.payload;
        state.loading = false;
      })
      .addCase(fetchServiceTypeData.rejected, handleRejection)

      .addCase(addBillSets.pending, (state) => {
        state.addBillsetLoading = true;
        state.isBillSetsCreated = false;
        state.addBillSetsError = '';
      })
      .addCase(addBillSets.fulfilled, (state) => {
        state.addBillsetLoading = false;
        state.isBillSetsCreated = true;
        state.addBillSetsError = '';
      })
      .addCase(addBillSets.rejected, (state, action) => {
        state.isBillSetsCreated = false;
        state.addBillSetsError =
          action?.payload?.response?.data ===
          OSS_BILL_SETS_DATA.BE_addAlreadyExist
            ? OSS_BILL_SETS_DATA.addAlreadyExist
            : ERROR_MESSAGE.globalError;
        state.addBillsetLoading = false;
      })

      .addCase(updateBillSets.pending, (state) => {
        state.dataUpdatingLoading = true;
        state.isBillSetsUpdated = false;
        state.updateBillSetsMessage = '';
      })
      .addCase(updateBillSets.fulfilled, (state) => {
        state.dataUpdatingLoading = false;
        state.isBillSetsUpdated = true;
        state.updateBillSetsMessage = OSS_BILL_SETS_DATA.oosBillSetUpdated;
      })
      .addCase(updateBillSets.rejected, (state, action) => {
        state.isBillSetsUpdated = false;
        state.dataUpdatingLoading = false;
        state.updateBillSetsMessage =
          action?.payload?.response?.data ===
          OSS_BILL_SETS_DATA.BE_updateAlreadyExist
            ? OSS_BILL_SETS_DATA.addAlreadyExist
            : action?.payload?.response?.data ===
              OSS_BILL_SETS_DATA.BE_updateDeleteError
            ? OSS_BILL_SETS_DATA.updateDeleteError
            : ERROR_MESSAGE.globalError;
      })

      .addCase(deleteBillSet.pending, (state) => {
        state.deleteButtonLoader = true;
        state.isBillSetDeleted = false;
      })
      .addCase(deleteBillSet.fulfilled, (state) => {
        state.deleteButtonLoader = false;
        state.isBillSetDeleted = true;
      })
      .addCase(deleteBillSet.rejected, (state) => {
        state.deleteButtonLoader = false;
        state.isBillSetDeleted = false;
      })

      .addCase(fetchOosBillSetsById.pending, (state) => {
        state.updateLoadding = true;
      })
      .addCase(fetchOosBillSetsById.fulfilled, (state, action) => {
        state.billSets = action?.payload?.billSets?.map((item) => {
          item['isNew'] = false;
          item['isDeleted'] = false;
          item.rules?.map((itemR) => {
            let startTime = itemR['startTime'].split(':');
            itemR['startTime'] = new Date().setHours(
              startTime[0],
              startTime[1]
            );
            let endTime = itemR['endTime'].split(':');
            itemR['endTime'] = new Date().setHours(endTime[0], endTime[1]);
            itemR['isNew'] = false;
            itemR['isDeleted'] = false;
          });
          return item;
        });
        state.billSetsInfo['name'] = action?.payload?.name;
        state.billSetsInfo['description'] = action?.payload?.description;
        state.billSetsErrors = JSON.parse(
          JSON.stringify(action?.payload?.billSets)
        );
        state.billSetsErrors?.map((item) => {
          item.countryId = null;
          item.currencyId = null;
          item.rules?.forEach((itemR) => {
            itemR.serviceTypeId = null;
            itemR.billCalcTypeID = null;
            itemR.startTime = null;
            itemR.endTime = null;
            itemR.baseMinuteQty = null;
            itemR.baseFee = null;
            itemR.incrementMinuteQty = null;
            itemR.incrementFee = null;
            return itemR;
          });
          return item;
        });
        state.updateLoadding = false;
      })
      .addCase(fetchOosBillSetsById.rejected, (state) => {
        state.updateLoadding = false;
      });
  },
});

export const {
  resetValues,
  setSelectedValue,
  setSearchTerm,
  setSelectedRowData,
  setFormFields,
  handleAddNewRule,
  handleSelectedTab,
  handlebillSetsCreateType,
  handleBillSetsFormCancle,
  handleAddValidationError,
  handleEditValidationError,
  handleDeleteValidationError,
  handleDeleteRule,
  handleEditRule,
  handleCheckboxChecked,
  handlebillSetsInfo,
  handlebillSetsInfoError,
  handleIsBillsetAdded,
  handlePagination,
  resetBackValue,
  backClickedSet
} = oosBillSetsSlice.actions;
export default oosBillSetsSlice.reducer;
